import type { ReactNode } from 'react';

import { ALL_BENEFITS } from './sections/Benefits/benefitData';

const CUSTOM_DESCRIPTIONS: Record<string, ReactNode> = {
  MONOGENIC: 'Understand your inherited risk for cancer, heart disease, and more',
  PGX: 'Understand how your genes may affect how certain medications work for you',
  BASELINE_RISK: 'Learn how your genetics influence your risk for this disease',
  FAMILY_VARIANT_TESTING: (
    <>
      A targeted test for the specific <i>CASR</i> gene change (variant) identified in your family, with genetic
      counseling included
    </>
  ),
};

const BENEFIT_DESCRIPTIONS: Record<string, ReactNode> = Object.fromEntries(
  ALL_BENEFITS.map(b => [b.title, b.description]),
);

export const getProductDescription = (reportType: string, title: string, apiDescription: string): ReactNode => {
  return CUSTOM_DESCRIPTIONS[reportType] ?? BENEFIT_DESCRIPTIONS[title] ?? apiDescription;
};
